import { demoBuyerMe } from '../dev/buyerDemoData'
import { withDemoUi } from '../dev/demoMode'
import { apiRequest } from './client'
import type { MeResponse } from './types'

// Терпимость к обоим написаниям на проводе: API нормализуется к snake_case,
// поэтому читаем camelCase, а при его отсутствии — snake_case.
// Особенно важно для displayName: SettingsScreen делает по нему .split(' ').
type MeRaw = MeResponse & {
  display_name?: string
}

const normalizeMe = (raw: MeRaw): MeResponse => ({
  ...raw,
  displayName: raw.displayName ?? raw.display_name ?? '',
})

export const fetchMe = () =>
  withDemoUi(demoBuyerMe(), () => apiRequest<MeRaw>('/me').then(normalizeMe))

export const updateProfile = (request: { email: string }) =>
  apiRequest<MeRaw>('/me', {
    method: 'PATCH',
    body: {
      email: request.email.trim(),
    },
  }).then(normalizeMe)
